/* PhotoMed — interatividade das sections próprias da home.
   Degrada sem JS: o conteúdo inicial já é válido e legível. */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     1) Explorador de espectro
     --------------------------------------------------------- */
  var BANDS = [
    { max: 450, name: 'Luz azul',        color: '#6C7BE8', depth: 0.4,
      what: 'Acción antibacteriana',
      desc: 'Actúa en la superficie de la piel. Es la longitud de onda que se emplea contra la bacteria implicada en el acné.',
      uses: ['Acné', 'Piel grasa', 'Poros'], link: '/collections/cuidado-facial' },
    { max: 570, name: 'Luz verde',       color: '#4BB98A', depth: 0.7,
      what: 'Tono y manchas',
      desc: 'Penetra hasta la unión dermo-epidérmica. Se asocia a un tono más uniforme y a la atenuación de manchas.',
      uses: ['Manchas', 'Rojeces', 'Tono desigual'], link: '/collections/cuidado-facial' },
    { max: 700, name: 'Luz roja',        color: '#E24A3C', depth: 2.5,
      what: 'Firmeza y colágeno',
      desc: 'La longitud de onda más estudiada en dermatología. Alcanza la dermis, donde estimula la producción de colágeno y mejora la elasticidad.',
      uses: ['Arrugas', 'Firmeza', 'Luminosidad'], link: '/collections/mascarillas-led' },
    { max: 1000, name: 'Infrarrojo',     color: '#C1352B', depth: 5.5,
      what: 'Recuperación profunda',
      desc: 'Atraviesa la piel y llega al tejido muscular y articular. Es la banda asociada a la recuperación y al alivio de molestias.',
      uses: ['Músculos', 'Articulaciones', 'Circulación'], link: '/collections/terapia-luz-roja' }
  ];

  function bandFor(nm) {
    for (var i = 0; i < BANDS.length; i++) if (nm <= BANDS[i].max) return BANDS[i];
    return BANDS[BANDS.length - 1];
  }

  function initSpectrum(root) {
    var range = root.querySelector('[data-pm-range]');
    if (!range) return;
    var elNm    = root.querySelector('[data-pm-nm]'),
        elBand  = root.querySelector('[data-pm-band]'),
        elWhat  = root.querySelector('[data-pm-what]'),
        elDesc  = root.querySelector('[data-pm-desc]'),
        elUses  = root.querySelector('[data-pm-uses]'),
        elBeam  = root.querySelector('[data-pm-beam]'),
        elDepth = root.querySelector('[data-pm-depth]'),
        elLine  = root.querySelector('[data-pm-depthline]'),
        elLink  = root.querySelector('[data-pm-link]');

    function render(nm) {
      var b = bandFor(nm);
      root.style.setProperty('--pm-hue', b.color);
      // profundidade: 0.4mm -> 6% da altura | 5.5mm -> 88%
      var pct = Math.min(88, 6 + (b.depth / 5.5) * 82);
      if (elBeam)  elBeam.style.height = pct + '%';
      if (elLine)  elLine.style.top = pct + '%';
      if (elNm)    elNm.textContent = nm;
      if (elBand)  elBand.textContent = b.name;
      if (elWhat)  elWhat.textContent = b.what;
      if (elDesc)  elDesc.textContent = b.desc;
      if (elDepth) elDepth.textContent = String(b.depth).replace('.', ',') + ' mm';
      if (elLink)  elLink.setAttribute('href', b.link);
      if (elUses) {
        elUses.innerHTML = '';
        b.uses.forEach(function (u) {
          var s = document.createElement('span');
          s.className = 'pm-sx__chip';
          s.textContent = u;
          elUses.appendChild(s);
        });
      }
    }

    range.addEventListener('input', function () { render(parseInt(this.value, 10)); });
    root.querySelectorAll('[data-pm-jump]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = this.getAttribute('data-pm-jump');
        range.value = v;
        render(parseInt(v, 10));
      });
    });
    render(parseInt(range.value, 10));
  }

  /* ---------------------------------------------------------
     2) Mapa corporal — zonas clicáveis
     --------------------------------------------------------- */
  function initBodyMap(root) {
    var spots = root.querySelectorAll('[data-pm-zone]');
    var panels = root.querySelectorAll('[data-pm-zone-panel]');
    if (!spots.length) return;

    function show(id) {
      spots.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-pm-zone') === id);
        s.setAttribute('aria-selected', s.getAttribute('data-pm-zone') === id ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-pm-zone-panel') === id);
      });
    }
    spots.forEach(function (s) {
      s.addEventListener('click', function () { show(this.getAttribute('data-pm-zone')); });
      s.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
    show(spots[0].getAttribute('data-pm-zone'));
  }

  /* ---------------------------------------------------------
     3) Comparador de coste — clínica vs casa
     --------------------------------------------------------- */
  function initCost(root) {
    var range = root.querySelector('[data-pm-sessions]');
    if (!range) return;
    var perSession = parseFloat(root.getAttribute('data-clinic-price') || '150');
    var devicePrice = parseFloat(root.getAttribute('data-device-price') || '99.9');
    var elN = root.querySelector('[data-pm-n]'),
        elClinic = root.querySelector('[data-pm-clinic]'),
        elHome = root.querySelector('[data-pm-home]'),
        elSave = root.querySelector('[data-pm-save]'),
        barC = root.querySelector('[data-pm-bar-clinic]'),
        barH = root.querySelector('[data-pm-bar-home]');

    function money(v) {
      return v.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
    }
    function render(n) {
      var clinic = n * perSession;
      var max = Math.max(clinic, devicePrice, 1);
      if (elN) elN.textContent = n;
      if (elClinic) elClinic.textContent = money(clinic);
      if (elHome) elHome.textContent = money(devicePrice);
      if (barC) barC.style.width = (clinic / max * 100) + '%';
      if (barH) barH.style.width = (devicePrice / max * 100) + '%';
      if (elSave) {
        var diff = clinic - devicePrice;
        elSave.textContent = diff > 0 ? ('Ahorras ' + money(diff)) : 'Aún no compensa';
        elSave.classList.toggle('is-positive', diff > 0);
      }
    }
    range.addEventListener('input', function () { render(parseInt(this.value, 10)); });
    render(parseInt(range.value, 10));
  }

  /* ---------------------------------------------------------
     4) Protocolo semanal — dias
     --------------------------------------------------------- */
  function initProtocol(root) {
    var days = root.querySelectorAll('[data-pm-day]');
    var cards = root.querySelectorAll('[data-pm-day-card]');
    if (!days.length) return;
    function show(id) {
      days.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-pm-day') === id); });
      cards.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-pm-day-card') === id); });
    }
    days.forEach(function (d) {
      d.addEventListener('click', function () { show(this.getAttribute('data-pm-day')); });
      d.addEventListener('mouseenter', function () { show(this.getAttribute('data-pm-day')); });
    });
    show(days[0].getAttribute('data-pm-day'));
  }


  /* ---------------------------------------------------------
     5) Calculadora de dose (J/cm²)
     Dose = irradiância (mW/cm²) x tempo (s) / 1000
     --------------------------------------------------------- */
  function initDose(root) {
    var range = root.querySelector('[data-pm-dose-range]');
    if (!range) return;
    var irr = parseFloat(root.getAttribute('data-irradiance') || '7');
    var elMin = root.querySelector('[data-pm-min]'),
        elJ = root.querySelector('[data-pm-joules]'),
        elV = root.querySelector('[data-pm-verdict]'),
        elN = root.querySelector('[data-pm-note]'),
        elMk = root.querySelector('[data-pm-marker]');
    var sec = root.closest('section') || root;
    var notes = {
      low: sec.querySelector('[data-pm-dose]') ? null : null
    };

    function render(min) {
      var j = irr * min * 60 / 1000;              // J/cm²
      if (elMin) elMin.textContent = min;
      if (elJ) elJ.textContent = j.toFixed(1).replace('.', ',');

      var state = j < 3 ? 'low' : (j <= 20 ? 'ok' : 'high');
      var labels = { low: 'Dosis insuficiente', ok: 'Ventana terapéutica', high: 'Dosis excesiva' };
      if (elV) {
        elV.textContent = labels[state];
        elV.className = 'pm-dose__verdict is-' + state;
      }
      if (elN) {
        var key = 'note' + state.charAt(0).toUpperCase() + state.slice(1);
        elN.textContent = root.getAttribute('data-' + key) || elN.textContent;
      }
      // marcador: escala 0..24 J mapeada em 0..100%
      if (elMk) elMk.style.left = Math.min(100, (j / 24) * 100) + '%';
      root.setAttribute('data-state', state);
    }
    range.addEventListener('input', function () { render(parseInt(this.value, 10)); });
    render(parseInt(range.value, 10));
  }

  /* --------------------------------------------------------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-pm-spectrum]').forEach(initSpectrum);
    (scope || document).querySelectorAll('[data-pm-bodymap]').forEach(initBodyMap);
    (scope || document).querySelectorAll('[data-pm-cost]').forEach(initCost);
    (scope || document).querySelectorAll('[data-pm-protocol]').forEach(initProtocol);
    (scope || document).querySelectorAll('[data-pm-dose]').forEach(initDose);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  // editor do tema
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
